<template>
    <loading ref="loading"
             fullPage="true"
             :active.sync="loading"
             :can-cancel="false"
             :color="colorLoading"
             :height="heightLoading"
             :width="widthLoading"></loading>
</template>

<script>
import 'vue-loading-overlay/dist/vue-loading.css';
import Loading from 'vue-loading-overlay';

export default {
    data() {
        return {
            loading: false,
            colorLoading: "#17755A",
            heightLoading: 55,
            widthLoading: 55,
        }
    },
    components: {
        Loading
    },
    methods: {
        showLoading() {
            this.loading = true;
        },
        hideLoading() {
            this.loading = false;
        },
    }
}
</script>

<style>

</style>
